export default "__VITE_ASSET__5a3a7d2a__"